var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { bindFunctionsToThis } from '../../extensions';
import { BaseComponent } from '../base.component';
var RowActionButtonsComponent = /** @class */ (function (_super) {
    __extends(RowActionButtonsComponent, _super);
    function RowActionButtonsComponent() {
        var _this = _super.call(this) || this;
        bindFunctionsToThis(_this);
        return _this;
    }
    RowActionButtonsComponent.prototype.onClick = function ($event) {
        if (this.isLoading) {
            $event.stopPropagation();
            $event.preventDefault();
        }
    };
    RowActionButtonsComponent.prototype.startLoading = function () {
        this.isLoading = true;
    };
    RowActionButtonsComponent.prototype.stopLoading = function () {
        this.isLoading = false;
    };
    return RowActionButtonsComponent;
}(BaseComponent));
export { RowActionButtonsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/row.action.buttons/row.action.buttons.component.ts.pre-build-optimizer.js